module.exports = __webpack_public_path__ + "static/media/app-icon-transparent.14ba5e09.png";